import React from "react";
import { Eye, MapPin, Video } from "lucide-react";

const TalentRecentApplicationsTable = ({
  dashboardData,
  activeTab,
  setActiveTab,
  navigate,
  getStatusBadge
}) => {
  const filteredApps = dashboardData?.applications?.filter(row => 
    activeTab === "all" ? true : activeTab === "selected" ? row.status?.toLowerCase() === "selected" || row.status?.toLowerCase() === "shortlisted" : true
  ) || [];

  return (
    <div className="td-card td-table-card border border-secondary border-opacity-25 ">
      <div className="card-header pb-3 border-bottom border-secondary border-opacity-25 d-flex justify-content-between align-items-center">
        <h2 className="text-white fw-bold fs-5 m-0">Recent Applications</h2>
        <div className="table-filters d-flex gap-2">
          <button 
            className={`px-3 py-1 rounded-pill small fw-semibold border-0 ${activeTab === "all" ? "bg-secondary text-white" : "bg-transparent text-secondary"}`} 
            onClick={() => setActiveTab("all")}
          >
            All
          </button>
          <button 
            className={`px-3 py-1 rounded-pill small fw-semibold border-0 ${activeTab === "selected" ? "bg-secondary text-white" : "bg-transparent text-secondary"}`} 
            onClick={() => setActiveTab("selected")}
          >
            Shortlisted
          </button>
        </div>
      </div>
      <div className="table-responsive mt-3">
        <table className="table table-dark table-hover align-middle m-0 text-nowrap td-project-style-table">
          <thead>
            <tr className="text-uppercase text-secondary small border-bottom border-secondary border-opacity-25">
              <th className="py-3 px-3 text-center" style={{ width: '50px', color: '#9ca3af', fontSize: '0.75rem' }}>#</th>
              <th className="py-3 px-3" style={{ color: '#9ca3af', fontSize: '0.75rem' }}>PROJECT TITLE</th>
              <th className="py-3 px-3" style={{ color: '#9ca3af', fontSize: '0.75rem' }}>ROLE APPLIED</th>
              <th className="py-3 px-3" style={{ color: '#9ca3af', fontSize: '0.75rem' }}>TYPE</th>
              <th className="py-3 px-3" style={{ color: '#9ca3af', fontSize: '0.75rem' }}>APPLIED ON</th>
              <th className="py-3 px-3 text-center" style={{ color: '#9ca3af', fontSize: '0.75rem' }}>STATUS</th>
              <th className="py-3 px-3 text-center" style={{ width: '80px', color: '#9ca3af', fontSize: '0.75rem' }}>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {filteredApps.length > 0 ? (
              filteredApps.map((row, index) => (
                <tr key={row.id || index} className="border-bottom border-secondary border-opacity-10">
                  <td className="py-3 px-3 text-center text-secondary fw-semibold">{index + 1}</td>
                  <td className="py-3 px-3">
                    <span className="fw-bold text-white fs-6">{row.project}</span>
                  </td>
                  <td className="py-3 px-3 text-secondary">{row.role}</td>
                  <td className="py-3 px-3">
                    <span className="d-inline-flex align-items-center gap-1.5 text-secondary small">
                      {row.type?.includes("Online") ? <Video size={14} className="text-info" /> : <MapPin size={14} className="text-warning" />}
                      {row.type}
                    </span>
                  </td>
                  <td className="py-3 px-3 text-secondary small">{row.date}</td>
                  <td className="py-3 px-3 text-center">{getStatusBadge(row.status)}</td>
                  <td className="py-3 px-3 text-center">
                    <button
                      type="button"
                      className="d-inline-flex align-items-center justify-content-center"
                      style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '6px',
                        backgroundColor: '#2563eb',
                        border: 'none',
                        cursor: 'pointer',
                        padding: 0,
                        margin: '0 auto'
                      }}
                      title="View Details"
                      onClick={() => navigate(`/audition/${row.id}/${row.urlSlug || ''}`)}
                    >
                      <Eye size={16} color="#ffffff" />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4 text-secondary">No application records found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TalentRecentApplicationsTable;
